import { render, staticRenderFns } from "./PageDescription.vue?vue&type=template&id=733a350d&scoped=true"
import script from "./PageDescription.vue?vue&type=script&lang=js"
export * from "./PageDescription.vue?vue&type=script&lang=js"
import style0 from "./PageDescription.vue?vue&type=style&index=0&id=733a350d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733a350d",
  null
  
)

export default component.exports